
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education",
      function () {
        return require("private-next-pages/education.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education"])
      });
    }
  